import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";

// Lazy load below-the-fold components for better performance
const Problem = lazy(() => import("@/components/Problem"));
const WhatWeDo = lazy(() => import("@/components/WhatWeDo"));
const Method = lazy(() => import("@/components/Method"));
const Difference = lazy(() => import("@/components/Difference"));
const ApplicationForm = lazy(() => import("@/components/ApplicationForm"));
const Footer = lazy(() => import("@/components/Footer"));

// Simple loading fallback
const SectionFallback = () => (
  <div className="min-h-[200px] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const scrollToApply = () => {
    document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToMethod = () => {
    document.getElementById("method")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onApplyClick={scrollToApply} />
      <main>
        <Hero onApplyClick={scrollToApply} onLearnMoreClick={scrollToMethod} />
        <Suspense fallback={<SectionFallback />}>
          <Problem />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <WhatWeDo />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Method />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Difference />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <ApplicationForm />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
